module.exports = __webpack_public_path__ + "media/欢呼声.ffe4d327.wav";